<!-- <a href="/dashboard">Is Admin Login</a>
<div *ngFor="let row of portalList; index as i">
    <a class="dropdown-item" href="javascript:void(0)"
    (click)="onPortalSelect(row)">{{row.name}}</a>
</div> -->
<section class="ke-login-pro">
    <div class="ke-row-process">
        <div class="ke-pro-leftside">
            <div class="logo-login-white">
                <a href="#"> <img src="assets/images/logo-white.png" alt="logo-white"> </a>
            </div>
        </div>
        <div class="ke-pro-rightside">
            <div class="admin-top-btn">
                <div class="admin-login">
                    <button class="btn" (click)="onPortalSelect(false)">Admin Login</button>
                </div>
                <div class="admin-logout"> <button (click)="logout()">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0"
                            viewBox="0 0 320.002 320.002" style="enable-background:new 0 0 512 512" xml:space="preserve"
                            class="">
                            <g>
                                <g xmlns="http://www.w3.org/2000/svg" id="XMLID_6_">
                                    <path id="XMLID_7_"
                                        d="M51.213,175.001h173.785c8.284,0,15-6.716,15-15c0-8.284-6.716-15-15-15H51.213l19.394-19.394   c5.858-5.858,5.858-15.355,0-21.213c-5.857-5.858-15.355-5.858-21.213,0L4.396,149.393c-0.351,0.351-0.683,0.719-0.997,1.103   c-0.137,0.167-0.256,0.344-0.385,0.515c-0.165,0.22-0.335,0.435-0.488,0.664c-0.14,0.209-0.261,0.426-0.389,0.64   c-0.123,0.206-0.252,0.407-0.365,0.619c-0.118,0.22-0.217,0.446-0.323,0.67c-0.104,0.219-0.213,0.435-0.306,0.659   c-0.09,0.219-0.164,0.442-0.243,0.664c-0.087,0.24-0.179,0.477-0.253,0.722c-0.067,0.222-0.116,0.447-0.172,0.672   c-0.063,0.249-0.133,0.497-0.183,0.751c-0.051,0.259-0.082,0.521-0.119,0.782c-0.032,0.223-0.075,0.443-0.097,0.669   c-0.048,0.484-0.073,0.971-0.074,1.457c0,0.007-0.001,0.015-0.001,0.022c0,0.007,0.001,0.015,0.001,0.022   c0.001,0.487,0.026,0.973,0.074,1.458c0.022,0.223,0.064,0.44,0.095,0.661c0.038,0.264,0.069,0.528,0.121,0.79   c0.05,0.252,0.119,0.496,0.182,0.743c0.057,0.227,0.107,0.456,0.175,0.681c0.073,0.241,0.164,0.474,0.248,0.71   c0.081,0.226,0.155,0.453,0.247,0.675c0.091,0.22,0.198,0.431,0.3,0.646c0.108,0.229,0.21,0.46,0.33,0.685   c0.11,0.205,0.235,0.4,0.354,0.599c0.131,0.221,0.256,0.444,0.4,0.659c0.146,0.219,0.309,0.424,0.466,0.635   c0.136,0.181,0.262,0.368,0.407,0.544c0.299,0.364,0.616,0.713,0.947,1.048c0.016,0.016,0.029,0.034,0.045,0.05l45,45.001   c2.93,2.929,6.768,4.394,10.607,4.394c3.838-0.001,7.678-1.465,10.606-4.393c5.858-5.858,5.858-15.355,0.001-21.213L51.213,175.001   z"
                                        fill="#53959d" data-original="#000000" style="" />
                                    <path id="XMLID_8_"
                                        d="M305.002,25h-190c-8.284,0-15,6.716-15,15v60c0,8.284,6.716,15,15,15s15-6.716,15-15V55h160v210.001h-160   v-45.001c0-8.284-6.716-15-15-15s-15,6.716-15,15v60.001c0,8.284,6.716,15,15,15h190c8.284,0,15-6.716,15-15V40   C320.002,31.716,313.286,25,305.002,25z"
                                        fill="#53959d" data-original="#000000" style="" />
                                </g>
                                <g xmlns="http://www.w3.org/2000/svg">
                                </g>
                                <g xmlns="http://www.w3.org/2000/svg">
                                </g>
                                <g xmlns="http://www.w3.org/2000/svg">
                                </g>
                                <g xmlns="http://www.w3.org/2000/svg">
                                </g>
                                <g xmlns="http://www.w3.org/2000/svg">
                                </g>
                                <g xmlns="http://www.w3.org/2000/svg">
                                </g>
                                <g xmlns="http://www.w3.org/2000/svg">
                                </g>
                                <g xmlns="http://www.w3.org/2000/svg">
                                </g>
                                <g xmlns="http://www.w3.org/2000/svg">
                                </g>
                                <g xmlns="http://www.w3.org/2000/svg">
                                </g>
                                <g xmlns="http://www.w3.org/2000/svg">
                                </g>
                                <g xmlns="http://www.w3.org/2000/svg">
                                </g>
                                <g xmlns="http://www.w3.org/2000/svg">
                                </g>
                                <g xmlns="http://www.w3.org/2000/svg">
                                </g>
                                <g xmlns="http://www.w3.org/2000/svg">
                                </g>
                            </g>
                        </svg>
                    </button></div>
            </div>
            <!-- <div class="admin-login">
                <button class="btn" (click)="logout()">Logout</button>
            </div> -->
            <div class="row">
                <div class="col-lg-12">
                    <div class="wrh-head" *ngIf='warehouseList.length>0'>
                        <h4>Select Warehouse</h4>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-lg-6 col-sm-12 mt-4" *ngFor="let row of warehouseList; index as i">
                    <a href="javascript:void(0)" class="service-content" title="{{row.name}}">
                        <div class="shadow-box android rev" (click)="onPortalSelect(row)">
                            <div class="service-icon">
                                <img [src]="row.flagUrl" alt="logo-white"
                                    onerror="this.onerror=null;this.src='assets/images/no-img.png'">
                                <!-- select image from database -->
                            </div>
                            <h3 class="service-title">{{row.name}}</h3>
                        </div>
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="wrh-head sapce-top" *ngIf='franchiseeList.length>0'>
                        <h4>Select Franchisee</h4>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-lg-6 col-sm-12 mt-4" *ngFor="let row of franchiseeList; index as i">
                    <a href="javascript:void(0)" class="service-content" title="{{row.name}}">
                        <div class="shadow-box android rev" (click)="onPortalSelect(row)">
                            <div class="service-icon">
                                <img [src]="row.flagUrl" alt="logo-white"
                                    onerror="this.onerror=null;this.src='assets/images/no-img.png'">
                                <!-- select image from database -->
                            </div>
                            <h3 class="service-title">{{row.name}}</h3>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>